module.exports = __webpack_public_path__ + "static/img/home-village.da6b002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-img/home-village.jpg
// module id = IVWR
// module chunks = 183